// src/redux/actions/errorActions.js
import { CLEAR_ERROR, SET_ERROR } from "../Actions/types";

export const setError = (message, type = "error") => ({
  type: SET_ERROR,
  payload: { message, type },
});

export const clearError = () => ({ type: CLEAR_ERROR });
